const userActivationEvents = ['click', 'touchstart'];

export default function checkStorageAccess(callback) {
  const requestAccess = createRequestAccess(callback);

  return document.hasStorageAccess().then((hasAccess) => {
    if (hasAccess) {
      return true;
    }
    userActivationEvents.forEach((event) => self.addEventListener(event, requestAccess, true));
  });

  function createRequestAccess(callback) {
    return function() {
      document.requestStorageAccess().then((hasAccess) => {
        callback(hasAccess);
        userActivationEvents.forEach((eventName) => {
          self.removeEventListener(eventName, requestAccess, true);
        });
      });
    };
  }
}

